import React from 'react'
import PropTypes from 'prop-types'

import { Box, Text } from '@piconetworks/ui'

const Value = ({ children, className, handleEdit }) => {

    return (
        <Box.Flexbox.Container
            justifyContent='start'
            flexDirection='column'
            className={className}
            onClick={handleEdit}
        >
            <Text.Span>{children}</Text.Span>
        </Box.Flexbox.Container>
    )
}

Value.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    handleEdit: PropTypes.func,
}

export default Value
